'use client';

import { c as _c } from "react/compiler-runtime";
import useUser from '@shared/utils/hooks/useUser';
import { Activity, CreditCard, Lock, Palette, Plug, Settings as SettingsIcon, Shield, User as UserIcon } from 'lucide-react';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import MultiPage, { type SubpagesObjectType } from '../../layouts/MultiPage';
import Billing from '../settings/Billing';
import ConnectedApps from '../settings/ConnectedApps';
import Preferences from '../settings/Preferences';
import Privacy from '../settings/Privacy';
import Security from '../settings/Security';
import Sessions from '../settings/Sessions';
import Theme from '../settings/Theme';
import User from '../settings/User';
type SettingsProps = {
  slug?: string;
  basePath: string;
  backPath?: string;
};
const Settings = t0 => {
  const $ = _c(7);
  const {
    slug,
    basePath,
    backPath
  } = t0;
  const {
    currentUser
  } = useUser();
  let t1;
  if ($[0] !== currentUser.isAuthenticated) {
    t1 = currentUser.isAuthenticated ? [{
      title: "Preferences",
      slug: "preferences",
      icon: <SettingsIcon height={15} width={15} />,
      component: <Preferences />
    }, {
      title: "Theme",
      slug: "theme",
      icon: <Palette height={15} width={15} />,
      component: <Theme />
    }, {
      title: "User",
      slug: "user",
      icon: <UserIcon height={15} width={15} />,
      component: <User />
    }, {
      title: "Billing",
      slug: "billing",
      icon: <CreditCard height={15} width={15} />,
      component: <Billing />
    }, {
      title: "Privacy",
      slug: "privacy",
      icon: <Lock height={15} width={15} />,
      component: <Privacy />
    }, {
      title: "Security",
      slug: "security",
      icon: <Shield height={15} width={15} />,
      component: <Security />
    }, {
      title: "Sessions",
      slug: "sessions",
      icon: <Activity height={15} width={15} />,
      component: <Sessions />
    }, {
      title: "Connected Apps",
      slug: "connected-apps",
      icon: <Plug height={15} width={15} />,
      component: <ConnectedApps />
    }] : [{
      title: "Preferences",
      slug: "preferences",
      icon: <SettingsIcon height={15} width={15} />,
      component: <Preferences />
    }, {
      title: "Theme",
      slug: "theme",
      icon: <Palette height={15} width={15} />,
      component: <Theme />
    }];
    $[0] = currentUser.isAuthenticated;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subpages = t1;
  let t2;
  if ($[2] !== backPath || $[3] !== basePath || $[4] !== slug || $[5] !== subpages) {
    t2 = <AppLayout fullWidth={true}><MultiPage title="Settings" subpages={subpages} backButtonEnabled={true} slug={slug} basePath={basePath} backPath={backPath} /></AppLayout>;
    $[2] = backPath;
    $[3] = basePath;
    $[4] = slug;
    $[5] = subpages;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default Settings;